import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg";
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";
import Work6 from "../../assets/work6.jpg";
import Work7 from "../../assets/work7.jpg";
import Work8 from "../../assets/work8.jpg";
import Work9 from "../../assets/work9.jpg";
import Work10 from "../../assets/work10.jpg";

export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Text Utility WebApp",
      category: "app",
      link: "https://textutils-ca.vercel.app/"
    },
    // {
    //   id: 3,
    //   image: Work3,
    //   title: "Brand design",
    //   category: "design",
    // },
    {
      id: 5,
      image: Work5,
      title: "College Conference Website",
      category: "web",
      link: "https://icamc2023.onrender.com/"

    },
    {
      id: 6,
      image: Work6,
      title: "Keeper WebApp",
      category: "web",
      link: "https://nymyze.csb.app/"

    },
    {
      id: 7,
      image: Work7,
      title: "GSAP Scroll",
      category: "design",
      link: "https://chaitanyarora.github.io/scroll-using-gsap/"

    },
    {
      id: 8,
      image: Work8,
      title: "GSAP Animation",
      category: "web",
      link: "https://chaitanyarora.github.io/animation-gsap/"

    },
    {
      id: 9,
      image: Work9,
      title: "Three.js & WebGL 3D Animation",
      category: "web",
      link: "https://chaitanyarora.github.io/WebGL-Three.js-donut/"

    },
    {
      id: 10,
      image: Work10,
      title: "Lenis Smooth Scroll",
      category: "web",
      link: "https://chaitanyarora.github.io/lenis-smoothscroll/"

    },
  ];

export const projectsNav = [
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "app",
    },
    {
        name: "design",
    },
]